<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
             <div class="card-header">
                <h4 class="card-title">Lot Mapping</h4>
             </div>
             <div class="card-body">
                <LotMap/>
             </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LotMap from '@/components/LotMap.vue';
export default {
    name: 'Home-Page',
  components: {
    LotMap,
  },
}
</script>

<style lang="scss" scoped>

</style>